<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisPropertySearch from 'dashboard/components-next/LaisPropertySearch.vue';

defineProps({
  propertyMaterializing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['selectCatalogSearchResult']);

const selectedCatalogItem = defineModel('selectedCatalogItem', {
  type: Object,
  default: null,
});
const selectedCatalogMode = defineModel('selectedCatalogMode', {
  type: String,
  default: '',
});
const catalogQuery = defineModel('catalogQuery', {
  type: String,
  default: '',
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="grid gap-4">
    <LaisPropertySearch
      v-model="selectedCatalogItem"
      v-model:source="selectedCatalogMode"
      v-model:query="catalogQuery"
      required
      include-empreendimentos
      treat-properties-as-portfolio
      label="Buscar imóvel"
      helper="Busca integrada na carteira, imóveis na casa e empreendimentos por código, rua, bairro, cidade ou endereço completo."
      @select="emit('selectCatalogSearchResult', $event)"
    />
    <div
      v-if="propertyMaterializing"
      class="flex items-center gap-2 rounded-lais border border-lais-border bg-lais-bg-soft px-4 py-3 text-[13px] text-lais-text-body"
    >
      <span
        class="i-lucide-loader-circle size-4 animate-spin text-lais-primary"
        aria-hidden="true"
      />
      Preparando imóvel na casa para criar a proposta.
    </div>
  </section>
</template>
